<!-- <template>
  <div>
    <Overlay :overlay="overlay" />
    <ViolationAcknowledged
      :Acknowledged="Acknowledged"
      @clicked="AcknowledgedEmit"
    />
    <VideoCallDialog
      :VideoCallDialog="VideoCallDialog"
      @clicked="VideoCallEmit"
    />
    <v-app-bar
      dense
      app
      class="elevation-0 white--text"
      color="blueColorVariant9"
    >
      <v-btn icon small color="white" @click="PushToMainPage()"
        ><v-icon>mdi-arrow-left-bold</v-icon></v-btn
      >
      <v-img
        rounded
        max-width="40px"
        max-height="40px"
        class="ml-5 ImageRadius"
        contain
        :src="profile_pic_url"
      ></v-img>
      <span class="ml-2">{{
        this.$store.getters.get_motorist_name.user_name
      }}</span>
      <v-spacer />
      <v-btn icon color="white" @click="VideoCallMethod()"
        ><v-icon>mdi-video</v-icon></v-btn
      ></v-app-bar
    >
    <div
      class="content"
      align="center"
      ref="messageContainer"
      style="height: calc(100vh); overflow-y: auto"
    >
      <v-col cols="12" md="8" xs="12" sm="8">
        <v-card class="elevation-0">
          <v-card
            tile
            v-for="message in reversedMessages"
            :key="message.message_id"
            class="message-card elevation-0"
          >
            <v-card-text class="py-0">
              <v-spacer v-if="isCurrentUser(message.messaged_by_id)" />
              <v-col
                :class="{
                  'text-right': isCurrentUser(message.messaged_by_id),
                  'text-left': !isCurrentUser(message.messaged_by_id),
                }"
              >
                <div
                  class="message-text"
                  :class="{
                    'green-background': isCurrentUser(message.messaged_by_id),
                    'purple-background': !isCurrentUser(message.messaged_by_id),
                  }"
                >
                  <span class="">{{ message.message_text }}</span>
                </div>
                <div class="">
                  {{ new Date(message.messaged_on).toLocaleString() }}
                </div>
              </v-col>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
    </div>

    <v-footer class="fixed-bottom pa-0" elevation="0" color="#d3d3d3">
      <v-row justify="center">
        <v-col cols="12" md="8" xs="10" sm="10" align="center" class="">
          <v-textarea
            v-model="CreateChat"
            label="Type..."
            outlined
            dense
            rows="1"
            auto-grow
            filled
            solo
            @keydown.enter="SendMessagesMethod(CreateChat)"
            class="mt-4 ml-16"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="1" xs="2" sm="2" class="">
          <v-btn
            v-if="CreateChat != ''"
            @click="SendMessagesMethod(CreateChat)"
            icon
            color="primary"
            class="mt-5"
          >
            <v-icon large>mdi-send</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import { CreateChat } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";
import { GetAllChats } from "@/mixins/Chat/ListChats.js";
import { GetAllMessages } from "@/mixins/Chat/ListMessages.js";
import { SendMessages } from "@/mixins/Chat/SendMessage.js";
import { RecieveMessages } from "@/mixins/Chat/RecieveChatSub.js";
import { RecieveVideoCallSub } from "@/mixins/Chat/VideoCallSub.js";
import { FireNotification } from "@/mixins/Chat/TriggerMessage.js";
import { SendVideoCallNotification } from "@/mixins/Chat/SendVideoCall.js";
import { GenerateS3URL } from "@/mixins/ImageUpload.js";
import Overlay from "@/components/Extras/Overlay.vue";
import VideoCallDialog from "@/components/Extras/VideoCallDialog.vue";
import ViolationAcknowledged from "@/components/Violations/Dialogs/ViolationAcknoledged.vue";
export default {
  components: {
    VideoCallDialog,
    Overlay,
    ViolationAcknowledged,
  },
  mixins: [
    GetAllChats,
    GetAllMessages,
    SendMessages,
    RecieveMessages,
    RecieveVideoCallSub,
    FireNotification,
    SendVideoCallNotification,
    GenerateS3URL,
  ],
  computed: {
    reversedMessages() {
      return this.MessagesList.slice().reverse();
    },
  },
  async created() {
    await this.subscribeToRecieveMessages();
    await this.subscribeToRecieveVideoCall();
  },
  data: () => ({
    CreateChat: "",
    overlay: false,
    current_user_id: "current_user_id",
    VideoCallDialog: false,
    Acknowledged: false,
    profile_pic_url: "",
    userDetailsObject: {},
  }),
  watch: {
    MessagesList(newValue, oldValue) {
      if (this.MessagesList.length > 2) {
        if (newValue.length > oldValue.length) {
          this.scrollToBottom();
        }
      }
    },
  },
  async mounted() {
    this.userDetailsObject = this.$store.getters.get_motorist_name;
    this.GetImage();
    await this.CreateChatMethod();
    this.GetAllChatsMethod();

    this.GetAllMessagesMethod();
    this.scrollToBottom();
  },
  methods: {
    async GetImage() {
      if (
        this.userDetailsObject.profile_pic_url.includes(
          "https://makeithomesafe.s3.us-east-1.amazonaws.com//"
        )
      ) {
        const ProfileImg = this.userDetailsObject.profile_pic_url;
        const Frontparts = ProfileImg.split("/");
        const ProfilePicImg = Frontparts.pop();
        this.profile_pic_url = await this.GenerateS3URLMethods(
          `/${ProfilePicImg}`
        );
      } else {
        const Profile_Image = this.userDetailsObject.profile_pic_url;
        this.profile_pic_url = await this.GenerateS3URLMethods(Profile_Image);
      }
    },
    VideoCallMethod() {
      this.SendVideoCallMethod();
      this.$router.push("/VideoCall");
    },
    TimeConvert(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);
      const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      return formattedDateTime;
    },
    isCurrentUser(userId) {
      return userId === this.$store.getters.get_current_user_details.user_id;
    },
    async CreateChatMethod() {
      try {
        this.loading = true;
        var inputParams = {
          police_user_id: this.$store.getters.get_current_user_details.user_id,
          motorist_user_id: this.$store.getters.get_motorist_name.user_id,
          chat_created_by: "Police",
        };
        let result = await API.graphql(
          graphqlOperation(CreateChat, {
            input: inputParams,
          })
        );
        this.loading = false;
        var ResultObject = JSON.parse(result.data.CreateChat);
        this.$store.commit("SET_CHAT_ID", ResultObject.chat_id);
      } catch (error) {
        console.log("err", error);
      }
    },
    VideoCallEmit() {
      this.VideoCallDialog = false;
    },
    AlignMessageMethod() {
      this.MessagesList.forEach((item) => {
        return item;
      });
    },
    PushToMainPage() {
      this.$router.push("/PlateLookUp");
    },
    scrollToBottom() {
      const container = this.$refs.messageContainer;
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight;
      });
    },
    AcknowledgedEmit() {
      this.Acknowledged = false;
    },
  },
};
</script>

<style scoped>
.content {
  margin-bottom: 70px !important;
}
.v-footer {
  background-color: #f0f0f0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 1000;
}

.text-right {
  text-align: right;
  color: green;
}
.text-left {
  text-align: left;
}

.message-card {
  margin-bottom: 0px;
}

.message-text {
  padding: 8px;
  border-radius: 8px;
  display: inline-block;
  max-width: 70%;
}

.green-background {
  background-color: rgb(112, 95, 227);
  color: white;
  text-align: right;
}

.purple-background {
  background-color: rgb(234, 226, 234);
  color: black;
  text-align: left;
}
.fixed-bottom {
  background-color: #f0f0f0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
</style> -->

<template>
  <div class="d-flex flex-column" style="height: 100vh">
    <Overlay :overlay="overlay" />
    <ViolationAcknowledged
      :Acknowledged="Acknowledged"
      @clicked="AcknowledgedEmit"
    />
    <VideoCallDialog
      :VideoCallDialog="VideoCallDialog"
      @clicked="VideoCallEmit"
    />
    <v-app-bar
      dense
      app
      class="elevation-0 white--text"
      color="blueColorVariant9"
    >
      <v-btn icon small color="white" @click="PushToMainPage()">
        <v-icon>mdi-arrow-left-bold</v-icon>
      </v-btn>
      <v-img
        rounded
        max-width="40px"
        max-height="40px"
        class="ml-5 ImageRadius"
        contain
        :src="profile_pic_url"
      ></v-img>
      <span class="ml-2">
        {{ this.$store.getters.get_motorist_name.user_name }}
      </span>
      <v-spacer />
      <v-btn icon color="white" @click="VideoCallMethod()">
        <v-icon>mdi-video</v-icon>
      </v-btn>
    </v-app-bar>

    <div
      class="content flex-grow-1 overflow-auto"
      align="center"
      ref="messageContainer"
      style="overflow-y: auto"
    >
      <v-col cols="12" md="8" xs="12" sm="8">
        <v-card class="elevation-0">
          <v-card
            tile
            v-for="message in reversedMessages"
            :key="message.message_id"
            class="message-card elevation-0 mb-5"
          >
            <v-card-text class="py-0">
              <v-spacer v-if="isCurrentUser(message.messaged_by_id)" />
              <v-col
                :class="{
                  'text-right': isCurrentUser(message.messaged_by_id),
                  'text-left': !isCurrentUser(message.messaged_by_id),
                }"
              >
                <div
                  class="message-text"
                  :class="{
                    'green-background': isCurrentUser(message.messaged_by_id),
                    'purple-background': !isCurrentUser(message.messaged_by_id),
                  }"
                >
                  <span>{{ message.message_text }}</span>
                </div>
                <div>
                  {{ new Date(message.messaged_on).toLocaleString() }}
                </div>
              </v-col>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
    </div>

    <v-footer class="pa-0" elevation="0" color="#d3d3d3">
      <v-row justify="center">
        <v-col cols="10" md="8" xs="10" sm="10" align="center" class="mt-2">
          <v-textarea
            v-model="CreateChat"
            label="Type..."
            outlined
            dense
            rows="1"
            auto-grow
            filled
            solo
            @keydown.enter="SendMessagesMethod(CreateChat)"
            class="textareaborder ml-3"
          ></v-textarea>
        </v-col>
        <v-col cols="2" md="1" xs="2" sm="2">
          <v-btn
            v-if="CreateChat !== ''"
            @click="SendMessagesMethod(CreateChat)"
            icon
            x-large
            color="primary"
            class="mt-1 ml-n6"
          >
            <v-icon x-large>mdi-send-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import { CreateChat } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";
import { GetAllChats } from "@/mixins/Chat/ListChats.js";
import { GetAllMessages } from "@/mixins/Chat/ListMessages.js";
import { SendMessages } from "@/mixins/Chat/SendMessage.js";
import { RecieveMessages } from "@/mixins/Chat/RecieveChatSub.js";
import { RecieveVideoCallSub } from "@/mixins/Chat/VideoCallSub.js";
import { FireNotification } from "@/mixins/Chat/TriggerMessage.js";
import { SendVideoCallNotification } from "@/mixins/Chat/SendVideoCall.js";
import { GenerateS3URL } from "@/mixins/ImageUpload.js";
import Overlay from "@/components/Extras/Overlay.vue";
import VideoCallDialog from "@/components/Extras/VideoCallDialog.vue";
import ViolationAcknowledged from "@/components/Violations/Dialogs/ViolationAcknoledged.vue";
export default {
  components: {
    VideoCallDialog,
    Overlay,
    ViolationAcknowledged,
  },
  mixins: [
    GetAllChats,
    GetAllMessages,
    SendMessages,
    RecieveMessages,
    RecieveVideoCallSub,
    FireNotification,
    SendVideoCallNotification,
    GenerateS3URL,
  ],
  computed: {
    reversedMessages() {
      return this.MessagesList.slice().reverse();
    },
  },
  async created() {
    await this.subscribeToRecieveMessages();
    await this.subscribeToRecieveVideoCall();
  },
  data: () => ({
    CreateChat: "",
    overlay: false,
    current_user_id: "current_user_id",
    VideoCallDialog: false,
    Acknowledged: false,
    profile_pic_url: "",
    userDetailsObject: {},
  }),
  watch: {
    MessagesList(newValue, oldValue) {
      if (this.MessagesList.length > 2) {
        if (newValue.length > oldValue.length) {
          this.scrollToBottom();
        }
      }
    },
  },
  async mounted() {
    this.userDetailsObject = this.$store.getters.get_motorist_name;
    this.GetImage();
    await this.CreateChatMethod();
    this.GetAllChatsMethod();

    this.GetAllMessagesMethod();
    this.scrollToBottom();
  },
  methods: {
    async GetImage() {
      if (
        this.userDetailsObject.profile_pic_url.includes(
          "https://makeithomesafe.s3.us-east-1.amazonaws.com//"
        )
      ) {
        const ProfileImg = this.userDetailsObject.profile_pic_url;
        const Frontparts = ProfileImg.split("/");
        const ProfilePicImg = Frontparts.pop();
        this.profile_pic_url = await this.GenerateS3URLMethods(
          `/${ProfilePicImg}`
        );
      } else {
        const Profile_Image = this.userDetailsObject.profile_pic_url;
        this.profile_pic_url = await this.GenerateS3URLMethods(Profile_Image);
      }
    },
    VideoCallMethod() {
      this.SendVideoCallMethod();
      this.$router.push("/VideoCall");
    },
    TimeConvert(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);
      const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      return formattedDateTime;
    },
    isCurrentUser(userId) {
      return userId === this.$store.getters.get_current_user_details.user_id;
    },
    async CreateChatMethod() {
      try {
        this.loading = true;
        var inputParams = {
          police_user_id: this.$store.getters.get_current_user_details.user_id,
          motorist_user_id: this.$store.getters.get_motorist_name.user_id,
          chat_created_by: "Police",
        };
        let result = await API.graphql(
          graphqlOperation(CreateChat, {
            input: inputParams,
          })
        );
        this.loading = false;
        var ResultObject = JSON.parse(result.data.CreateChat);
        this.$store.commit("SET_CHAT_ID", ResultObject.chat_id);
      } catch (error) {
        console.log("err", error);
      }
    },
    VideoCallEmit() {
      this.VideoCallDialog = false;
    },
    AlignMessageMethod() {
      this.MessagesList.forEach((item) => {
        return item;
      });
    },
    PushToMainPage() {
      this.$router.push("/PlateLookUp");
    },
    scrollToBottom() {
      const container = this.$refs.messageContainer;
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight;
      });
    },
    AcknowledgedEmit() {
      this.Acknowledged = false;
    },
  },
};
</script>

<style scoped>
.content {
  margin-bottom: 70px !important;
}
.v-footer {
  background-color: #d3d3d3;
  position: fixed;
  height: auto !important;
  bottom: 0;
  width: 100%;
  z-index: 1000;
}

.text-right {
  text-align: right;
  color: green;
}
.text-left {
  text-align: left;
}

.message-card {
  margin-bottom: 0px;
}

.message-text {
  padding: 8px;
  border-radius: 8px;
  display: inline-block;
  max-width: 70%;
}

.green-background {
  background-color: rgb(112, 95, 227);
  color: white;
  text-align: right;
}

.purple-background {
  background-color: rgb(234, 226, 234);
  color: black;
  text-align: left;
}
.textareaborder {
  border-radius: 20px !important;
}
</style>
